import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Scale, ArrowRight, BookOpen } from "lucide-react";
import { Logo, Wordmark } from "@/components/Logo";

export default function PreviewList() {
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    api.get("/preview/courses").then((r) => setCourses(r.data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border">
        <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5"><Logo className="w-7 h-7" /><Wordmark className="font-serif text-xl" /></Link>
          <Link to="/register" className="text-sm bg-primary text-primary-foreground px-4 py-2 rounded-sm">Enroll Now</Link>
        </div>
      </header>

      <div className="max-w-6xl mx-auto px-6 py-14">
        <span className="text-xs uppercase tracking-widest font-mono text-primary">Free Previews</span>
        <h1 className="font-serif text-5xl mt-2 mb-3">Read the first lesson of any course — free</h1>
        <p className="text-muted-foreground max-w-2xl mb-12">No account needed. Sample any course, then join to unlock the rest.</p>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-border border border-border">
          {courses.map((c) => (
            <Link key={c.slug} to={`/preview/${c.slug}`} data-testid={`preview-card-${c.slug}`} className="bg-card group hover:bg-muted transition-colors">
              <div className="h-32 bg-cover bg-center grain" style={{ backgroundImage: `url('${c.image}')` }} />
              <div className="p-6">
                <span className="text-[10px] uppercase tracking-widest font-mono text-primary">{c.category}</span>
                <h2 className="font-serif text-xl mt-1 leading-tight">{c.title}</h2>
                <span className="mt-4 inline-flex items-center gap-1.5 text-xs uppercase tracking-widest font-mono text-primary opacity-0 group-hover:opacity-100 transition-opacity">
                  <BookOpen className="w-3 h-3" /> Read lesson 1 <ArrowRight className="w-3 h-3" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
